/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GonzaloApiRequestObject {
  areaCostCoefficient?: number;
  circuitTurnsMinimumAngle?: number;
  fieldEntrance?: Array<number>;
  fieldPolygon?: Array<Array<number>>;
  fullConcaveTurns?: boolean;
  internalPattern?: string;
  maxHeadlandCircuits?: number;
  patternStart?: string;
  subdivide?: boolean;
  thresholdCollinearAngle?: number;
  thresholdRightAngle?: number;
  timeCostCoefficient?: number;
  turnOffset?: number;
  turningRadius?: number;
  turningSpeedPercentage?: number;
  workingAngle?: string;
  workingAngleDegree?: number;
  workingSpeed?: number;
  workingWidth?: number;
}
